import { usePermissionsStore } from '@/store/permissions';

/**
 * v-permission="'CUSTOMER:C'" removes the element from the DOM if the
 * current user lacks that permission. Permissions don't change mid-session
 * (only refetched on next login), so a mounted-only check is enough - no
 * need to react to store changes after render.
 */
export default {
  mounted(el, binding) {
    const permissionKey = binding.value;
    if (!permissionKey) return;

    const permissionsStore = usePermissionsStore();
    if (!permissionsStore.can(permissionKey)) {
      el.remove();
    }
  }
};
